import React, { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { Route, Switch, useLocation, useHistory } from 'react-router-dom'
import { SnackbarProvider } from 'notistack'

import { useBoot } from 'Core/Hooks/useBoot'
import useAppView from 'Core/Hooks/useAppView'
import Notifier from 'Utils/Notifier'
import { LayoutProvider } from 'features/layout'
import AdminRoutes from './admin'
import UserRoutes from './user'
import { NotFound } from 'features/layout'

function Routes() {
  const { bootComplete } = useBoot()
  const user = useSelector((state) => state.user)
  const isAuthenticated = user?.loggedIn
  const { appView } = useAppView()

  const location = useLocation()
  const history = useHistory()

  // Capture entry path ONCE
  const initialPathRef = useRef(location.pathname)

  useEffect(() => {
    if (!bootComplete || !isAuthenticated) return

    // Redirect ONLY if user truly landed on root
    if (
      initialPathRef.current === '/' ||
      initialPathRef.current === '/index.html' ||
      initialPathRef.current === '/user/'
    ) {
      history.replace(appView === 'admin' ? '/admin/dashboard' : '/user/targets')
    }
  }, [bootComplete, isAuthenticated, appView, history])

  return (
    <SnackbarProvider maxSnack={1}>
      <Notifier />

      <Switch>
        {isAuthenticated && (
          <Route path='/*'>
            <LayoutProvider>
              {bootComplete && (
                <Switch>
                  {/* ADMIN */}
                  <Route path='/admin'>
                    <AdminRoutes />
                  </Route>

                  {/* USER */}
                  <Route path='/user'>
                    <UserRoutes />
                  </Route>

                  {/* FALLBACK */}
                  <Route>
                    <NotFound />
                  </Route>
                </Switch>
              )}
            </LayoutProvider>
          </Route>
        )}
      </Switch>
    </SnackbarProvider>
  )
}

export { Routes }
